// src/authConfig.ts

import { Configuration } from "@azure/msal-browser";

// Hämta från dina .env-filer
const clientId = import.meta.env.VITE_AZURE_CLIENT_ID;
const tenantId = import.meta.env.VITE_AZURE_TENANT_ID;
const redirectUri = import.meta.env.VITE_AZURE_REDIRECT_URI;

// 1) Om du använder delegated permission i SharePoint “Sites.Read.All” + “admin consent”
//    kan du fortsätta med denna scope:
const sharepointScope = `https://solkompaniet365.sharepoint.com/.default`;

// 2) Om du hellre vill använda Microsoft Graph (obs, då byter du endpoint), ex:
// const graphScopes = ["https://graph.microsoft.com/Sites.Read.All"];

export const msalConfig: Configuration = {
  auth: {
    clientId,
    authority: `https://login.microsoftonline.com/${tenantId}`,
    redirectUri,
  },
  cache: {
    cacheLocation: "sessionStorage", // eller localStorage
  },
};

export const tokenRequest = {
  // scopen du behöver
  scopes: [sharepointScope],
};
